/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from './StyleConstant';
import CheckBoxRender from '../../../System/priceType/components/checkBoxRender';
import { caseInsensitiveComparator } from '../../../Display/NDC/utility/tableHeads';
import { qtrComparator } from '../../../../SharedModules/utilities/utilities';

export const labelerTableHead = [
  {
    headerName: 'Labeler Code',
    field: 'labelerCode',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Labeler Name',
    field: 'labelerName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    comparator: caseInsensitiveComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const manufacturersTableHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'manufacturersId',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_550,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'manufacturersName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_550,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const NDCTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellRenderer: 'HyperLinkNameRender',
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: {},
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const UnitConversionDetailTableHead = [
  {
    headerName: 'Index',
    field: 'indexNumber',
    hide: true,
    sortable: true,
    sort: 'asc',
  },
  {
    headerName: 'Comments Exists',
    field: 'ccCommentExist',
    hideFilterIcon: true,
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    minWidth: Styles.Width_170,
    cellEditor: MaxLengthNumericEditor,
    showCheckboxIcon: true,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'ActionCellRender',
  },
  {
    headerName: 'Start Qtr',
    field: 'startQTR',
    editable: false,
    sortable: true,
    sort: 'asc',
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditorPopup: true,
    cellClass: 'ag-cell-textfield',
    cellStyle: { borderRightColor: Styles.BorderColor },
    required: true,
    cellRenderer: 'TextBoxCellRender1',
    comparator: qtrComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Qtr',
    field: 'endQTR',
    editable: false,
    sortable: true,
    comparator: qtrComparator,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-textfield',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellRenderer: 'TextBoxCellRender1',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Billed Unit Factor',
    field: 'billedUnitFactor',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: 205,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    required: true,
    cellClass: 'ag-cell-textfield',
    cellRenderer: 'TextBoxCellRender1',
    excelAlignment: 'right',
    dataAlignRight: true,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CMS Unit Factor',
    field: 'cmsUnitFactor',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    required: true,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-textfield',
    dataAlignRight: true,
    excelAlignment: 'right',
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    cellRenderer: 'TextBoxCellRender1',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim Category',
    field: 'ucClaimCategoryCD',
    editable: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_45,
    required: true,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellEditorPopup: true,
    cellRenderer: 'DropDownCellRender1',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'HCPCS Code',
    field: 'procedureCD',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_170,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-textfield frr-display-hidden-label',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellRenderer: 'ProcedureCDTextBoxCellRender',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Rebate Program',
    field: 'ucRebateProgramCD',
    editable: true,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    required: true,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'DropDownCellRender2',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Unit Type',
    field: 'dramsUnitTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_175,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-textfield',
    cellRenderer: 'TextBoxCellRender',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CMS Unit Type',
    field: 'unitTypeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_175,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellRenderer: 'TextBoxCellRender',
    cellClass: 'ag-cell-textfield',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Delete allowed',
    field: 'ucDeleteAllowed',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_170,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellRenderer: 'TabFuncRender',
    cellClass: 'ag-cell-textfield',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const frameworkComponents = {
  checkboxRenderer: CheckBoxRender,
};

export const rebateProgramTableHead = [
  {
    headerName: 'Rebate Program CD',
    field: 'rebateProgramCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Description',
    field: 'shortDescr',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientTableHead = [
  {
    headerName: 'Super Client Name',
    field: 'superClientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_1000,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const groupTableHead = [
  {
    headerName: 'Group Id',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_600,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const contactGroupTableHead = [
  {
    headerName: 'Group Id',
    field: 'groupId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Group Name',
    field: 'groupName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Start Date',
    field: 'startDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'End Date',
    field: 'endDt',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const superClientModalHead = [
  {
    headerName: 'Client ID',
    field: 'clientId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client Name',
    field: 'clientName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
